"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrossrefClient = void 0;
const FetchHttpRequest_1 = require("./core/FetchHttpRequest");
const DepositsService_1 = require("./services/DepositsService");
const FundersService_1 = require("./services/FundersService");
const JournalsService_1 = require("./services/JournalsService");
const LicensesService_1 = require("./services/LicensesService");
const MembersService_1 = require("./services/MembersService");
const PrefixesService_1 = require("./services/PrefixesService");
const TypesService_1 = require("./services/TypesService");
const WorksService_1 = require("./services/WorksService");
class CrossrefClient {
    constructor(config, HttpRequest = FetchHttpRequest_1.FetchHttpRequest) {
        var _a, _b, _c, _d;
        this.request = new HttpRequest({
            BASE: (_a = config === null || config === void 0 ? void 0 : config.BASE) !== null && _a !== void 0 ? _a : '',
            VERSION: (_b = config === null || config === void 0 ? void 0 : config.VERSION) !== null && _b !== void 0 ? _b : '0.1',
            WITH_CREDENTIALS: (_c = config === null || config === void 0 ? void 0 : config.WITH_CREDENTIALS) !== null && _c !== void 0 ? _c : false,
            CREDENTIALS: (_d = config === null || config === void 0 ? void 0 : config.CREDENTIALS) !== null && _d !== void 0 ? _d : 'include',
            TOKEN: config === null || config === void 0 ? void 0 : config.TOKEN,
            USERNAME: config === null || config === void 0 ? void 0 : config.USERNAME,
            PASSWORD: config === null || config === void 0 ? void 0 : config.PASSWORD,
            HEADERS: config === null || config === void 0 ? void 0 : config.HEADERS,
            ENCODE_PATH: config === null || config === void 0 ? void 0 : config.ENCODE_PATH,
        });
        this.deposits = new DepositsService_1.DepositsService(this.request);
        this.funders = new FundersService_1.FundersService(this.request);
        this.journals = new JournalsService_1.JournalsService(this.request);
        this.licenses = new LicensesService_1.LicensesService(this.request);
        this.members = new MembersService_1.MembersService(this.request);
        this.prefixes = new PrefixesService_1.PrefixesService(this.request);
        this.types = new TypesService_1.TypesService(this.request);
        this.works = new WorksService_1.WorksService(this.request);
    }
}
exports.CrossrefClient = CrossrefClient;
//# sourceMappingURL=CrossrefClient.js.map